export const LOCAL = 'E0';
export const DEV = 'E1';
export const QA = 'E2';
export const PROD = 'E3';


/**
 * Gets environment tier (E0, E1, E2, E3) based on given hostname.
 */
 const getEnvFromHost = (hostname: string): string => {
    const environments: { [index: string]: string } = {
      localhost: LOCAL,
      "acquisition-dev.americanexpress.com": DEV,
      "acquisition-1-dev.americanexpress.com": DEV,
      "acquisition-2-dev.americanexpress.com": DEV,
      "acquisition-3-dev.americanexpress.com": DEV,
      "acquisition-4-dev.americanexpress.com": DEV,
      "acquisition-6-dev.americanexpress.com": DEV,
      "acquisition-green-qa.americanexpress.com": QA,
      "acquisition-1-green-qa.americanexpress.com": QA,
      "acquisition-2-green-qa.americanexpress.com": QA,
      "acquisition-3-green-qa.americanexpress.com": QA,
      "acquisition-4-green-qa.americanexpress.com": QA,
      "acquisition-qa.americanexpress.com": QA,
      "acquisition-1-qa.americanexpress.com": QA,
      "acquisition-2-qa.americanexpress.com": QA,
      "acquisition-3-qa.americanexpress.com": QA,
      "acquisition-4-qa.americanexpress.com": QA,
      "acquisition-6-qa.americanexpress.com": QA,
      "gcsfe-qa.americanexpress.com": QA,
      "gcsfe1-qa.americanexpress.com": QA,
      "gcsfe2-qa.americanexpress.com": QA,
      "gcsfe3-qa.americanexpress.com": QA,
      "gcsfe4-qa.americanexpress.com": QA,
      "gcsfe5-qa.americanexpress.com": QA,
      "qwww.americanexpress.com": QA,
      "acquisition2.americanexpress.com": PROD,
      "www.americanexpress.com": PROD
    };

    return environments[hostname] || PROD;
  };

const ENV_MAP: { [index: string]: string } = {
  [LOCAL]: "https://qicm.americanexpress.com",
  [DEV]: "https://qicm.americanexpress.com",
  [QA]: "https://qicm.americanexpress.com",
  [PROD]: "https://icm.aexp-static.com"
};

/**
 * Gets static host based on given hostname.
 */
export const getStaticHost = (hostname: string): string =>
  ENV_MAP[getEnvFromHost(hostname)];
